
export default {
name: 'getVoucher',
components: {

},
data () {
return {
voucherData: {},
showGetSuccessDialog: false,
}
},
methods: {
getCanReceiveVoucher () {
this.$request.post('/couponDetail/coupon',{

}).then(data => {
if(data.code == 0){
this.voucherData = data.obj
}else{
if(data.obj != '暂无可参加的活动'){
this.$vux.toast.show({
type: 'cancel',
text: data.obj
})
}
}
}).catch(e => {
console.log(e)
})
},
getVoucher () {
this.$request.post('/couponDetail/getCoupon',{

}).then(data => {
if(data.code == 0){
this.showGetSuccessDialog = true
this.voucherData.receive = false
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.obj
})
}
}).catch(e => {
console.log(e)
if(e.code == 9999){
this.$vux.toast.show({
type: 'warn',
text: e.obj
})
}
})
}
},
created () {
this.getCanReceiveVoucher()
},
mounted() {

}
}



// WEBPACK FOOTER //
// ./src/views/getVoucher/script.js